<template>
  <DialogBase
    v-model="showBasicSetupComponent"
    title="Basic Setup"
    :showCloseButton="false"
    persistent
    max-width="90vw"
    fullscreen
    scrollable
  >
    <template #dialogContent>
      <v-stepper v-model="stepperFrom" vertical flat>
        <v-stepper-header class="white rounded-lg" style="box-shadow: none">
          <v-stepper-step
            step="3"
            :complete="stepperFrom == 3"
            :color="stepperFrom >= 3 ? 'success' : 'primary'"
          >
            Branch
          </v-stepper-step>
          <v-stepper-step
            step="4"
            :complete="stepperFrom == 4"
            :color="stepperFrom > 4 ? 'success' : 'primary'"
          >
            Project
          </v-stepper-step>
          <v-stepper-step
            step="5"
            :complete="stepperFrom == 5"
            :color="stepperFrom > 5 ? 'success' : 'primary'"
          >
            Warehouse
          </v-stepper-step>
        </v-stepper-header>
        <v-stepper-items
          class="background_color pa-0 ma-0 ba"
          style="height: 87vh; max-height: 90vh; overflow-y: auto"
        >
          <v-stepper-content step="2" class="pa-0 ma-0">
            <BranchForm
              v-if="stepperFrom == 2"
              :editMode="false"
              :isHeader="false"
              :refreshProfileDetails="true"
              ref="branchForm"
              @redirect="redirect"
            />
          </v-stepper-content>
          <v-stepper-content step="3" class="pa-0 ma-0">
            <ProjectForm
              v-if="stepperFrom == 3"
              :editMode="false"
              :isHeader="false"
              :isBranchDisable="true"
              ref="projectForm"
              @redirect="redirect"
            />
          </v-stepper-content>
          <v-stepper-content step="4" class="pa-0 ma-0">
            <WarehouseForm
              v-if="stepperFrom == 4"
              :editMode="false"
              :isHeader="false"
              :isBranchDisable="true"
              ref="warehouseForm"
              @redirect="redirect"
            />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </template>
    <template #dialogActions>
      <SecondaryButton
        v-if="stepperFrom == 2 || stepperFrom == 3 || stepperFrom == 4"
        name="Skip"
        text
        btnClass="text-uppercase"
        @click="redirect"
      />
      <PrimaryButton
        id="companiesSubmit"
        btnClass="text-uppercase rounded-lg"
        name="Submit"
        @click="submitForm()"
      />
    </template>
  </DialogBase>
</template>

<script>
import DialogBase from "@/components/BaseComponents/DialogBase.vue";
import BranchForm from "@/components/ModuleBasedComponents/Branch/BranchForm.vue";
import ProjectForm from "@/components/ModuleBasedComponents/Project/ProjectForm.vue";
import WarehouseForm from "@/components/ModuleBasedComponents/Warehouse/WarehouseForm.vue";
export default {
  components: { DialogBase, BranchForm, ProjectForm, WarehouseForm },
  data() {
    return {
      stepperFrom: 1,
      isSubmitAnotherForm: false,
      stepperList: ["Branch", "Project", "Warehouse"],
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    startingStep: {
      type: Number,
    },
  },
  watch: {
    value(val) {
      if (val && this.startingStep) {
        this.stepperFrom = this.startingStep;
      }
    },
  },
  computed: {
    showBasicSetupComponent: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    submitForm() {
      if (this.stepperFrom == 2) {
        this.$refs.branchForm.submitForm();
      } else if (this.stepperFrom == 3) {
        this.$refs.projectForm.submitForm();
      } else if (this.stepperFrom == 4) {
        this.$refs.warehouseForm.submitForm();
      }
    },
    redirect() {
      if (this.stepperFrom == 4) {
        this.$root.$confirm(
          "Great Job!",
          "You've successfully completed the basic setup! You can now start using the system!",
          {
            hasCancle: false,
            agreeBtnText: "Nice!",
          }
        );
        this.showBasicSetupComponent = false;
        this.$confetti.start();
        let elem = document.getElementById("confetti-canvas");
        elem.style.zIndex = 201;
        setTimeout(() => {
          this.$confetti.stop();
        }, 3000);
      } else {
        this.stepperFrom++;
      }
    },
  },
};
</script>

<style></style>
